"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class WanabiError extends Error {
    constructor(message, log) {
        // console.warn(log)
        super(message);
        this.name = 'WanabiError' + (typeof log !== 'undefined' ? ': ' + JSON.stringify(log) : '');
    }
}
class SyntaxError extends WanabiError {
}
exports.SyntaxError = SyntaxError;
// wrong turn, no such card, etc.
class GameError extends WanabiError {
}
exports.GameError = GameError;
//# sourceMappingURL=errors.js.map